/* ============================================================================
   LAH — FOTO DO HOVER ACOMPANHA A COR ESCOLHIDA NO CARTAO
   Tema: Claude 21.0 (Green Friday)

   O tema troca a foto principal quando o cliente clica numa bolinha, mas a
   foto do hover ficava presa a cor inicial. Cada cor tem a sua foto de hover
   (snippets/lah-card-hover.liquid), ligada pela foto principal da cor em
   data-lah-cor-media. Aqui so mostramos a da cor escolhida.

   O cartao e renderizado varias vezes por pagina; a guarda abaixo evita
   registrar o listener mais de uma vez.
   ============================================================================ */
(function () {
    'use strict';
    if (window.__lahCardHover) return;
    window.__lahCardHover = true;

    document.addEventListener('change', function (event) {
        var radio = event.target;
        if (!radio.classList || !radio.classList.contains('color-swatch__radio')) return;

        var item = radio.closest('product-item');
        if (!item) return;

        var mediaId = radio.getAttribute('data-variant-featured-media');
        if (!mediaId) return;

        var alvo = item.querySelector('.product-item__secondary-image[data-lah-cor-media="' + mediaId + '"]');
        if (!alvo) return;

        var fotos = item.querySelectorAll('.product-item__secondary-image[data-lah-cor-media]');
        for (var i = 0; i < fotos.length; i++) {
            if (fotos[i] === alvo) {
                fotos[i].removeAttribute('hidden');
                fotos[i].style.display = '';
            } else {
                fotos[i].setAttribute('hidden', '');
                fotos[i].style.display = 'none';
            }
        }
    });
})();
